// extracted by mini-css-extract-plugin
module.exports = {"show-xs":"index_show-xs_1Ew1L","hide-xs":"index_hide-xs_2L_vL","breadcrumbs":"index_breadcrumbs_1PNOq","path":"index_path_2H21N","arrow":"index_arrow_1cdLN"};